"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const Title_1 = require("../Title");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
const organisms_1 = require("../../organisms");
const react_dom_1 = require("react-dom");
function MultiSelectionTitle() {
    const [mode, setMode] = (0, react_1.useState)(organisms_1.MultiSelectionMode.None);
    const [mounted, setMounted] = (0, react_1.useState)(false);
    const { isActive } = (0, hooks_1.useMultiSelectState)();
    (0, react_1.useEffect)(() => {
        setMounted(true);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            setMode(organisms_1.MultiSelectionMode.None);
        }
    }, [isActive, setMode]);
    const onClick = (newMode) => () => {
        setMode(newMode);
    };
    const onSelectionEnd = (0, react_1.useCallback)(() => {
        setMode(organisms_1.MultiSelectionMode.None);
    }, [setMode]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [mounted
                ? (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(organisms_1.AreaSelection, { selectionMode: mode, onSelectionEnd: onSelectionEnd, "data-e2e": 'MultiSelectionTitle_AreaSelection' }), document.getElementById('area-selection-portal'))
                : null, (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'MultiSelectionTitle_Container', children: [(0, jsx_runtime_1.jsx)(Title_1.Title, { title: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.title), "data-e2e": 'MultiSelectionTitle_Title' }), (0, jsx_runtime_1.jsxs)(Footer, { "data-e2e": 'MultiSelectionTitle_Footer', children: [(0, jsx_runtime_1.jsx)(atoms_1.AreaSelectionButton, { iconName: ui_1.Icons.Multi_Selection_Select_Area, label: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.selectArea), selected: mode === organisms_1.MultiSelectionMode.Select, onClick: onClick(organisms_1.MultiSelectionMode.Select), "data-e2e": 'MultiSelectionTitle_AreaSelectionButton' }), (0, jsx_runtime_1.jsx)(atoms_1.AreaSelectionButton, { iconName: ui_1.Icons.Multi_Selection_Deselect_Area, label: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.deselectArea), selected: mode === organisms_1.MultiSelectionMode.Deselect, onClick: onClick(organisms_1.MultiSelectionMode.Deselect), "data-e2e": 'MultiSelectionTitle_AreaSelectionButton' })] })] })] }));
}
exports.MultiSelectionTitle = MultiSelectionTitle;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const Footer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`;
